import {
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";

import Contexts from "../../context/Contexts";


// ======================================================
// HELPERS
// ======================================================

const isoToday = () =>
  new Date()
    .toISOString()
    .slice(0, 10);


const N = (value) => {

  const n =
    Number(value);

  return Number.isFinite(n)
    ? n
    : 0;
};


const toMoney = (value) =>
  N(value).toLocaleString(
    "es-AR",
    {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  );

// ======================================================
// COMPONENTE
// ======================================================

export default function AcreditarPagoProgramadoModal({
  show,
  onHide,
  row,
  onConfirm,
}) {

  const dataContext =
    useContext(
      Contexts.DataContext
    );


  const {
    empresaSeleccionada,
    cajaAbierta,
    cajasTesoreria = [],
    bancosTabla = [],
    formasPagoTesoreria = [],
    proyectosTabla = [],
  } =
    dataContext || {};

  console.log(
    "CAJA ABIERTA DATA CONTEXT:",
    cajaAbierta
  );

  console.log(
    "FORMAS PAGO TESORERIA:",
    formasPagoTesoreria
  );

  // ======================================================
  // ESTADOS
  // ======================================================

  const [
    medio,
    setMedio,
  ] = useState("caja");


  const [
    cajaId,
    setCajaId,
  ] = useState("");


  const [
    bancoId,
    setBancoId,
  ] = useState("");


  const [
    echeqFechaVencimiento,
    setEcheqFechaVencimiento,
  ] = useState("");


  const [
    numeroEcheq,
    setNumeroEcheq,
  ] = useState("");


  const [
    fecha,
    setFecha,
  ] = useState(
    isoToday()
  );

  const [
    monto,
    setMonto,
  ] = useState("");


  const [
    descripcion,
    setDescripcion,
  ] = useState("");


  const [
    observaciones,
    setObservaciones,
  ] = useState("");


  const [
    proyectoId,
    setProyectoId,
  ] = useState("");


  const [
    aplicarVariasFacturas,
    setAplicarVariasFacturas,
  ] = useState(false);


  const [
    saving,
    setSaving,
  ] = useState(false);


  const [
    error,
    setError,
  ] = useState(null);

  // ======================================================
  // ACREDITACIÓN PARCIAL
  // ======================================================

  const [
    confirmarSaldo,
    setConfirmarSaldo,
  ] = useState(false);

  const [
    formaPagoId,
    setFormaPagoId,
  ] = useState("");

  // ======================================================
  // DATOS DERIVADOS
  // ======================================================

  const empresaId =
    row?.empresa_id ||
    empresaSeleccionada?.id ||
    null;


  const esAnticipo =
    row?.pago_programado_tipo ===
    "anticipo";

  const montoAplicado =
    Number(
      row?.monto_aplicado ??
      row?.importe_aplicado ??
      0
    );


  const montoBloqueado =
    montoAplicado > 0;

  /*
   * El monto original del Pago Programado.
   *
   * row.monto_base no cambia aunque el usuario
   * modifique el input "monto".
   */
  const montoOriginal =
    N(
      row?.monto_base
    );

  const montoNumero =
    N(
      monto
    );

  const diferenciaMonto =
    Math.max(
      0,
      montoOriginal - montoNumero
    );

  /*
   * Sólo permitimos esta lógica cuando el monto
   * realmente puede editarse.
   */
  const esAcreditacionParcial =
    !montoBloqueado &&
    montoNumero > 0 &&
    montoNumero < montoOriginal;

  const comprobantesAplicados =
    Array.isArray(
      row?.comprobantes_aplicados
    )
      ? row.comprobantes_aplicados
      : [];


  const numerosComprobantesAplicados =
    comprobantesAplicados
      .map(
        (c) =>
          c?.nrocomprobante ||
          null
      )
      .filter(Boolean);

  const formaPagoAutomatica =
    useMemo(() => {

      const descripcionBuscada =
        medio === "caja"
          ? "EFECTIVO"
          : medio === "echeq"
            ? "ECHEQ"
            : "TRANSFERENCIA";

      return (
        formasPagoTesoreria || []
      ).find(
        (fp) =>
          String(
            fp.descripcion || ""
          )
            .trim()
            .toUpperCase() ===
          descripcionBuscada
      ) || null;

    }, [
      formasPagoTesoreria,
      medio,
    ]);



  const bancosDisponibles =
    useMemo(() => {

      return bancosTabla || [];

    }, [
      bancosTabla,
    ]);


  // ======================================================
  // CAJAS EMPRESA
  // ======================================================

  // const cajasEmpresa =
  //   useMemo(
  //     () =>
  //       (cajasTesoreria || []).filter(
  //         (c) =>
  //           !empresaId ||
  //           !c.empresa_id ||
  //           Number(c.empresa_id) ===
  //           Number(empresaId)
  //       ),
  //     [
  //       cajasTesoreria,
  //       empresaId,
  //     ]
  //   );


  // ======================================================
  // PRECARGAR PAGO PROGRAMADO
  // ======================================================

  useEffect(
    () => {

      if (
        !show ||
        !row
      ) {
        return;
      }


      setError(null);

      setSaving(false);

      setConfirmarSaldo(false);

      // Fecha efectiva del pago:
      // por defecto hoy.
      setFecha(
        isoToday()
      );


      setMonto(
        String(
          N(row.monto_base)
        )
      );


      setDescripcion(
        row.descripcion ||
        ""
      );


      setObservaciones(
        row.observaciones ||
        ""
      );


      setProyectoId(
        row.proyecto_id
          ? String(
            row.proyecto_id
          )
          : ""
      );

      setFormaPagoId(
        row.formapago_id
          ? String(
            row.formapago_id
          )
          : ""
      );


      setAplicarVariasFacturas(
        false
      );


      // ================================================
      // MEDIO ORIGINAL PROGRAMADO
      // ================================================

      if (
        row.medio === "banco"
      ) {

        setMedio(
          "banco"
        );

      } else if (
        row.medio === "echeq"
      ) {

        setMedio(
          "echeq"
        );

      } else {

        setMedio(
          "caja"
        );
      }
      // ================================================
      // BANCO ORIGINAL
      // ================================================

      setBancoId(
        row.banco_id
          ? String(
            row.banco_id
          )
          : ""
      );

      setEcheqFechaVencimiento(
        row.echeq_fecha_vencimiento
          ? String(
            row.echeq_fecha_vencimiento
          )
          : ""
      );


      setNumeroEcheq("");
      // ================================================
      // CAJA ORIGINAL
      // ================================================

      // setCajaId(
      //   row.caja_id
      //     ? String(
      //       row.caja_id
      //     )
      //     : ""
      // );

    },
    [
      show,
      row,
    ]
  );


  // ======================================================
  // AUTOSELECCIONAR BANCO SI HAY UNO SOLO
  // ======================================================

  useEffect(
    () => {

      if (
        medio === "banco" &&
        !bancoId &&
        bancosDisponibles.length === 1
      ) {

        setBancoId(
          String(
            bancosDisponibles[0].id
          )
        );
      }

    },
    [
      medio,
      bancoId,
      bancosDisponibles,
    ]
  );


  // ======================================================
  // AUTOSELECCIONAR CAJA SI HAY UNA SOLA
  // ======================================================

  // useEffect(
  //   () => {

  //     if (
  //       medio === "caja" &&
  //       !cajaId &&
  //       cajasEmpresa.length === 1
  //     ) {

  //       setCajaId(
  //         String(
  //           cajasEmpresa[0].id
  //         )
  //       );
  //     }

  //   },
  //   [
  //     medio,
  //     cajaId,
  //     cajasEmpresa,
  //   ]
  // );


  // ======================================================
  // VALIDAR
  // ======================================================

  const validar = () => {

    if (!row?.id) {

      throw new Error(
        "No se indicó el pago programado"
      );
    }


    if (!fecha) {

      throw new Error(
        "Debe indicar la fecha de pago"
      );
    }


    if (
      !(N(monto) > 0)
    ) {

      throw new Error(
        "El monto debe ser mayor a cero"
      );
    }


    if (
      !descripcion.trim()
    ) {

      throw new Error(
        "Debe indicar una descripción"
      );
    }


    if (
      !["caja", "banco", "echeq"].includes(
        medio
      )
    ) {

      throw new Error(
        "Debe seleccionar una forma de pago"
      );
    }

    if (
      medio === "caja" &&
      (
        !cajaAbierta?.caja?.id ||
        cajaAbierta?.abierta !== true
      )
    ) {

      throw new Error(
        "No hay una caja abierta disponible para registrar el pago"
      );
    }
    if (
      ["banco", "echeq"].includes(medio) &&
      !bancoId
    ) {

      throw new Error(
        medio === "echeq"
          ? "Debe seleccionar el banco del eCheq"
          : "Debe seleccionar un banco"
      );
    }


    if (
      medio === "echeq" &&
      !echeqFechaVencimiento
    ) {

      throw new Error(
        "Debe indicar la fecha de vencimiento del eCheq"
      );
    }


    if (
      medio === "echeq" &&
      echeqFechaVencimiento < fecha
    ) {

      throw new Error(
        "La fecha de vencimiento del eCheq no puede ser anterior a la fecha de emisión"
      );
    }

    if (!formaPagoAutomatica?.id) {

      throw new Error(
        medio === "caja"
          ? "No se encontró la forma de pago Efectivo"
          : medio === "echeq"
            ? "No se encontró la forma de pago ECHEQ"
            : "No se encontró la forma de pago Transferencia"
      );
    }
    // if (!formaPagoId) {

    //   throw new Error(
    //     "Debe seleccionar una forma de pago"
    //   );
    // }

  };


  // ======================================================
  // CONFIRMAR
  // ======================================================

  // ======================================================
  // EJECUTAR ACREDITACIÓN
  // ======================================================

  const ejecutarAcreditacion =
    async ({
      generarSaldo = false,
    } = {}) => {

      try {

        setError(null);

        validar();

        setSaving(true);


        // ==================================================
        // 1. PREPARAR PAYLOAD DE ACREDITACIÓN
        // ==================================================

        const payload = {

          fecha_acreditacion:
            fecha,

          medio,

          formapago_id:
            Number(
              formaPagoAutomatica.id
            ),

          caja_id:
            medio === "caja"
              ? Number(
                cajaAbierta.caja.id
              )
              : null,

          banco_id:
            (
              medio === "banco" ||
              medio === "echeq"
            )
              ? Number(
                bancoId
              )
              : null,

          echeq_fecha_vencimiento:
            medio === "echeq"
              ? echeqFechaVencimiento
              : null,

          numero_echeq:
            medio === "echeq" &&
              numeroEcheq.trim()
              ? numeroEcheq.trim()
              : null,

          monto:
            montoNumero,

          descripcion:
            descripcion.trim(),

          observaciones:
            observaciones.trim() ||
            null,

          proyecto_id:
            proyectoId
              ? Number(
                proyectoId
              )
              : null,

          generar_abono_ctacte:
            esAnticipo
              ? false
              : aplicarVariasFacturas,
        };


        console.log(
          "AcreditarPagoProgramado payload:",
          payload
        );


        // ==================================================
        // 2. SI CORRESPONDE, CREAR PRIMERO EL NUEVO
        //    PAGO PROGRAMADO POR LA DIFERENCIA
        // ==================================================

        if (
          generarSaldo &&
          diferenciaMonto > 0
        ) {

          /*
           * IMPORTANTE:
           *
           * Los datos se toman del Pago Programado
           * ORIGINAL (row).
           *
           * El único dato que cambia es el monto.
           */

          console.log(
            "ROW COMPLETO PARA GENERAR SALDO:",
            row
          );

          console.log(
            "DATOS CATEGORIA ROW:",
            {
              categoriaegreso_id:
                row?.categoriaegreso_id,

              categoria_id:
                row?.categoria_id,

              categoria_nombre:
                row?.categoria_nombre,

              imputacioncontable_id:
                row?.imputacioncontable_id,

              pago_programado_id:
                row?.id,
            }
          );

          const payloadSaldo = {

            empresa_id:
              Number(
                row.empresa_id
              ),

            proveedor_id:
              Number(
                row.proveedor_id
              ),

            tipo:
              row.pago_programado_tipo ||
              row.tipo,

            medio:
              row.medio,

            fecha_programada:
              row.fecha_programada,

            monto:
              diferenciaMonto,

            descripcion:
              row.descripcion,

            observaciones:
              row.observaciones ||
              null,

            formapago_id:
              row.formapago_id
                ? Number(
                  row.formapago_id
                )
                : null,

            banco_id:
              row.banco_id
                ? Number(
                  row.banco_id
                )
                : null,

            caja_id:
              row.caja_id
                ? Number(
                  row.caja_id
                )
                : null,

            echeq_fecha_vencimiento:
              row.echeq_fecha_vencimiento ||
              null,

            categoriaegreso_id:
              row.categoriaegreso_id
                ? Number(
                  row.categoriaegreso_id
                )
                : null,

            imputacioncontable_id:
              row.imputacioncontable_id
                ? Number(
                  row.imputacioncontable_id
                )
                : null,

            proyecto_id:
              row.proyecto_id
                ? Number(
                  row.proyecto_id
                )
                : null,

            comprobanteegreso_id:
              row.comprobanteegreso_id
                ? Number(
                  row.comprobanteegreso_id
                )
                : null,

            idempotencyKey:
              `saldo-pago-programado-${row.id}-${Date.now()}`,
          };


          console.log(
            "CREANDO SALDO PAGO PROGRAMADO:",
            payloadSaldo
          );


          const resSaldo =
            await fetch(
              `${process.env.REACT_APP_API_URL}/pagos-programados`,
              {
                method:
                  "POST",

                credentials:
                  "include",

                headers: {
                  "Content-Type":
                    "application/json",
                },

                body:
                  JSON.stringify(
                    payloadSaldo
                  ),
              }
            );


          const jsonSaldo =
            await resSaldo
              .json()
              .catch(
                () => ({})
              );


          console.log(
            "RESPUESTA CREACIÓN SALDO:",
            resSaldo.status,
            jsonSaldo
          );


          if (!resSaldo.ok) {

            throw new Error(
              jsonSaldo?.error ||
              `No se pudo generar el nuevo Pago Programado por el saldo de ${toMoney(
                diferenciaMonto
              )}`
            );
          }
        }


        // ==================================================
        // 3. ACREDITAR EL PAGO ORIGINAL
        // ==================================================
        //
        // Esto queda AL FINAL intencionalmente.
        //
        // onConfirm puede cerrar/desmontar este modal.
        // Por eso el saldo ya debe estar creado antes.
        // ==================================================

        await onConfirm?.(
          payload
        );


        setConfirmarSaldo(
          false
        );


      } catch (e) {

        console.error(
          "AcreditarPagoProgramadoModal:",
          e
        );


        setError(
          e.message ||
          "No se pudo acreditar el pago programado"
        );


        setSaving(false);
      }
    };

  // ======================================================
  // CONFIRMAR
  // ======================================================

  const confirmar =
    async () => {

      try {

        setError(null);

        validar();


        /*
         * Si el importe es inferior al programado,
         * todavía NO acreditamos.
         *
         * Primero preguntamos qué hacer con el saldo.
         */
        if (
          esAcreditacionParcial
        ) {

          setConfirmarSaldo(
            true
          );

          return;
        }


        /*
         * Si se acredita el importe completo,
         * comportamiento normal.
         */
        await ejecutarAcreditacion({
          generarSaldo:
            false,
        });


      } catch (e) {

        setError(
          e.message ||
          "No se pudo acreditar el pago programado"
        );
      }
    };

  // ======================================================
  // CERRAR
  // ======================================================

  const cerrar = () => {

    if (saving) {
      return;
    }

    onHide?.();
  };


  // ======================================================
  // RENDER
  // ======================================================

  return (

    <Modal
      show={show}
      onHide={cerrar}
      centered
      size="lg"
      backdrop={
        saving
          ? "static"
          : true
      }
    >

      <Modal.Header
        closeButton={
          !saving
        }
      >

        <Modal.Title>
          Acreditar pago programado
        </Modal.Title>

      </Modal.Header>


      <Modal.Body>

        {error && (

          <Alert
            variant="danger"
          >

            {error}

          </Alert>

        )}


        {!row ? (

          <Alert
            variant="warning"
          >

            No se indicó el pago programado.

          </Alert>

        ) : (

          <>

            {/* ======================================= */}
            {/* DATOS DEL PAGO PROGRAMADO              */}
            {/* ======================================= */}

            <Row
              className="g-3 mb-3"
            >

              <Col md={6}>

                <Form.Group>

                  <Form.Label>
                    Proveedor
                  </Form.Label>

                  <Form.Control
                    value={
                      row.proveedor_nombre ||
                      ""
                    }
                    disabled
                  />

                </Form.Group>

              </Col>


              <Col md={6}>

                <Form.Group>

                  <Form.Label>
                    Tipo
                  </Form.Label>

                  <Form.Control
                    value={
                      esAnticipo
                        ? "Anticipo"
                        : "Egreso varios"
                    }
                    disabled
                  />

                </Form.Group>

              </Col>


              <Col md={4}>

                <Form.Group>

                  <Form.Label>
                    Fecha programada
                  </Form.Label>

                  <Form.Control
                    type="date"
                    value={
                      row.fecha_programada ||
                      ""
                    }
                    disabled
                  />

                </Form.Group>

              </Col>


              <Col md={4}>

                <Form.Group>

                  <Form.Label>
                    Categoría
                  </Form.Label>

                  <Form.Control
                    value={
                      row.categoria_nombre ||
                      ""
                    }
                    disabled
                  />

                </Form.Group>

              </Col>


              <Col md={4}>

                <Form.Group>

                  <Form.Label>
                    Monto programado
                  </Form.Label>

                  <Form.Control
                    value={
                      `${toMoney(
                        row.monto_base
                      )}`
                    }
                    disabled
                  />

                </Form.Group>

              </Col>

            </Row>


            <hr />


            {/* ======================================= */}
            {/* FORMA DE PAGO                          */}
            {/* ======================================= */}

            <Form.Group
              className="mb-3"
            >

              <Form.Label>
                Medio de pago
              </Form.Label>


              <div>

                <Form.Check
                  inline
                  type="radio"
                  name="medio-programado"
                  id="programado-medio-caja"
                  label="Caja / Efectivo"
                  value="caja"
                  checked={
                    medio === "caja"
                  }
                  disabled={
                    saving
                  }
                  onChange={() =>
                    setMedio(
                      "caja"
                    )
                  }
                />


                <Form.Check
                  inline
                  type="radio"
                  name="medio-programado"
                  id="programado-medio-banco"
                  label="Banco / Transferencia"
                  value="banco"
                  checked={
                    medio === "banco"
                  }
                  disabled={
                    saving
                  }
                  onChange={() =>
                    setMedio(
                      "banco"
                    )
                  }
                />

                <Form.Check
                  inline
                  type="radio"
                  name="medio-programado"
                  id="programado-medio-echeq"
                  label="eCheq"
                  value="echeq"
                  checked={
                    medio === "echeq"
                  }
                  disabled={
                    saving
                  }
                  onChange={() =>
                    setMedio(
                      "echeq"
                    )
                  }
                />

              </div>

            </Form.Group>
            {/* 
            <Form.Group
              className="mb-3"
            >

              <Form.Label>
                Forma de pago
              </Form.Label>

              <Form.Select
                value={
                  formaPagoId
                }
                disabled={
                  saving
                }
                onChange={(e) =>
                  setFormaPagoId(
                    e.target.value
                  )
                }
              >

                <option value="">
                  Seleccionar...
                </option>

                {(formasPagoTesoreria || []).map(
                  (fp) => (

                    <option
                      key={
                        fp.id
                      }
                      value={
                        fp.id
                      }
                    >
                      {
                        fp.descripcion ||
                        fp.nombre ||
                        `Forma de pago ${fp.id}`
                      }
                    </option>

                  )
                )}

              </Form.Select>

            </Form.Group> */}

            <Row
              className="g-3"
            >

              {/* ===================================== */}
              {/* CAJA                                  */}
              {/* ===================================== */}
              {medio === "caja" && (

                <Col md={6}>

                  <Form.Group>

                    <Form.Label>
                      Caja
                    </Form.Label>

                    <Form.Control
                      value={
                        cajaAbierta?.caja?.id
                          ? `Caja abierta #${cajaAbierta.caja.id}`
                          : "No hay caja abierta"
                      }
                      disabled
                    />

                    {cajaAbierta?.caja?.id && (
                      <Form.Text muted>
                        Saldo actual:
                        {toMoney(
                          cajaAbierta.saldo
                        )}
                      </Form.Text>
                    )}

                    {cajaAbierta?.id && (
                      <Form.Text muted>
                        Saldo actual:
                        {toMoney(
                          cajaAbierta.saldo
                        )}
                      </Form.Text>
                    )}

                  </Form.Group>

                </Col>

              )}


              {/* ===================================== */}
              {/* BANCO                                 */}
              {/* ===================================== */}

              {(
                medio === "banco" ||
                medio === "echeq"
              ) && (

                  <Col md={6}>

                    <Form.Group>

                      <Form.Label>
                        Banco
                      </Form.Label>

                      <Form.Select
                        value={
                          bancoId
                        }
                        disabled={
                          saving
                        }
                        onChange={(e) =>
                          setBancoId(
                            e.target.value
                          )
                        }
                      >

                        <option value="">
                          Seleccionar...
                        </option>


                        {bancosDisponibles.map(
                          (b) => (

                            <option
                              key={
                                b.id
                              }
                              value={
                                b.id
                              }
                            >

                              {
                                b.descripcion ||
                                b.nombre ||
                                `Banco ${b.id}`
                              }

                            </option>

                          )
                        )}

                      </Form.Select>

                    </Form.Group>

                  </Col>

                )}

              {medio === "echeq" && (

                <>

                  <Col md={6}>

                    <Form.Group>

                      <Form.Label>
                        Fecha de vencimiento del eCheq
                      </Form.Label>

                      <Form.Control
                        type="date"
                        value={
                          echeqFechaVencimiento
                        }
                        min={
                          fecha || undefined
                        }
                        disabled={
                          saving
                        }
                        onChange={(e) =>
                          setEcheqFechaVencimiento(
                            e.target.value
                          )
                        }
                        isInvalid={
                          !!echeqFechaVencimiento &&
                          !!fecha &&
                          echeqFechaVencimiento <
                          fecha
                        }
                      />

                      <Form.Control.Feedback
                        type="invalid"
                      >
                        El vencimiento no puede ser anterior
                        a la fecha de emisión.
                      </Form.Control.Feedback>

                    </Form.Group>

                  </Col>


                  <Col md={6}>

                    <Form.Group>

                      <Form.Label>
                        Número eCheq / Descripción
                      </Form.Label>

                      <Form.Control
                        value={
                          numeroEcheq
                        }
                        disabled={
                          saving
                        }
                        placeholder="Opcional"
                        onChange={(e) =>
                          setNumeroEcheq(
                            e.target.value
                          )
                        }
                      />

                    </Form.Group>

                  </Col>

                </>

              )}


              {/* ===================================== */}
              {/* FECHA REAL                            */}
              {/* ===================================== */}

              <Col md={6}>

                <Form.Group>

                  <Form.Label>
                    {medio === "echeq"
                      ? "Fecha de emisión"
                      : "Fecha de pago"}
                  </Form.Label>

                  <Form.Control
                    type="date"
                    value={
                      fecha
                    }
                    disabled={
                      saving
                    }
                    onChange={(e) =>
                      setFecha(
                        e.target.value
                      )
                    }
                  />

                </Form.Group>

              </Col>


              {/* ===================================== */}
              {/* MONTO                                 */}
              {/* ===================================== */}

              <Col md={6}>

                <Form.Group>

                  <Form.Label>
                    Monto a acreditar
                  </Form.Label>

                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    value={
                      monto
                    }
                    disabled={
                      saving ||
                      montoBloqueado
                    }
                    onChange={(e) => {

                      setMonto(
                        e.target.value
                      );

                      setConfirmarSaldo(
                        false
                      );
                    }}
                  />


                  {montoBloqueado ? (

                    <Form.Text className="text-warning">

                      El monto no puede modificarse porque este
                      Pago Programado está asociado a
                      {
                        numerosComprobantesAplicados.length > 1
                          ? " los comprobantes: "
                          : " el comprobante: "
                      }

                      <strong>
                        {
                          numerosComprobantesAplicados.length > 0
                            ? numerosComprobantesAplicados.join(", ")
                            : "asociado"
                        }
                      </strong>.

                    </Form.Text>

                  ) : (

                    <Form.Text muted>

                      Programado:
                      {toMoney(
                        row.monto_base
                      )}

                    </Form.Text>

                  )}

                </Form.Group>

              </Col>


              {/* ===================================== */}
              {/* PROYECTO                              */}
              {/* ===================================== */}

              <Col md={6}>

                <Form.Group>

                  <Form.Label>
                    Proyecto
                  </Form.Label>

                  <Form.Select
                    value={
                      proyectoId
                    }
                    disabled={
                      saving
                    }
                    onChange={(e) =>
                      setProyectoId(
                        e.target.value
                      )
                    }
                  >

                    <option value="">
                      Sin proyecto
                    </option>


                    {(proyectosTabla || []).map(
                      (p) => (

                        <option
                          key={
                            p.id
                          }
                          value={
                            p.id
                          }
                        >

                          {
                            p.nombre ||
                            p.descripcion ||
                            `Proyecto ${p.id}`
                          }

                        </option>

                      )
                    )}

                  </Form.Select>

                </Form.Group>

              </Col>


              {/* ===================================== */}
              {/* DESCRIPCIÓN                           */}
              {/* ===================================== */}

              <Col md={12}>

                <Form.Group>

                  <Form.Label>
                    Descripción
                  </Form.Label>

                  <Form.Control
                    value={
                      descripcion
                    }
                    disabled={
                      saving
                    }
                    onChange={(e) =>
                      setDescripcion(
                        e.target.value
                      )
                    }
                  />

                </Form.Group>

              </Col>


              {/* ===================================== */}
              {/* OBSERVACIONES                         */}
              {/* ===================================== */}

              <Col md={12}>

                <Form.Group>

                  <Form.Label>
                    Observaciones
                  </Form.Label>

                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={
                      observaciones
                    }
                    disabled={
                      saving
                    }
                    onChange={(e) =>
                      setObservaciones(
                        e.target.value
                      )
                    }
                  />

                </Form.Group>

              </Col>


              {/* ===================================== */}
              {/* VARIAS FACTURAS                       */}
              {/* ===================================== */}

              {/* {!esAnticipo && (

                <Col md={12}>

                  <Form.Check
                    type="checkbox"
                    id="varias-facturas-programado"
                    label="Este pago se aplicará a varias facturas"
                    checked={
                      aplicarVariasFacturas
                    }
                    disabled={
                      saving
                    }
                    onChange={(e) =>
                      setAplicarVariasFacturas(
                        e.target.checked
                      )
                    }
                  />


                  {aplicarVariasFacturas && (

                    <Form.Text muted>

                      Se generará un abono en la
                      cuenta corriente del proveedor
                      para distribuir posteriormente
                      este pago entre varias facturas.

                    </Form.Text>

                  )}

                </Col>

              )} */}


              {/* ===================================== */}
              {/* ANTICIPO                              */}
              {/* ===================================== */}

              {esAnticipo && (

                <Col md={12}>

                  <Alert
                    variant="light"
                    className="mb-0"
                  >

                    Este pago ya es un anticipo y
                    posee un abono en la cuenta
                    corriente del proveedor.

                  </Alert>

                </Col>

              )}

            </Row>

          </>

        )}

        {/* ============================================= */}
        {/* ACREDITACIÓN PARCIAL                          */}
        {/* ============================================= */}

        {confirmarSaldo &&
          esAcreditacionParcial && (

            <Alert
              variant="warning"
              className="mt-3 mb-0"
            >

              <div className="fw-bold mb-2">
                Acreditación parcial del Pago Programado
              </div>


              <div className="mb-3">
                El importe ingresado es menor al importe
                originalmente programado.
              </div>


              <Row className="g-2">

                <Col md={4}>

                  <div className="text-muted">
                    Importe original
                  </div>

                  <strong>
                    {toMoney(
                      montoOriginal
                    )}
                  </strong>

                </Col>


                <Col md={4}>

                  <div className="text-muted">
                    Importe a acreditar
                  </div>

                  <strong>
                    {toMoney(
                      montoNumero
                    )}
                  </strong>

                </Col>


                <Col md={4}>

                  <div className="text-muted">
                    Saldo pendiente
                  </div>

                  <strong>
                    {toMoney(
                      diferenciaMonto
                    )}
                  </strong>

                </Col>

              </Row>


              <hr />


              <div className="fw-bold">

                ¿Desea generar automáticamente un nuevo
                Pago Programado por{" "}

                {toMoney(
                  diferenciaMonto
                )}{" "}

                con los mismos datos del Pago Programado
                original?

              </div>

            </Alert>

          )}

      </Modal.Body>


      <Modal.Footer>

        {confirmarSaldo &&
          esAcreditacionParcial ? (

          <>
            <Button
              variant="secondary"
              type="button"
              disabled={saving}
              onClick={() =>
                setConfirmarSaldo(
                  false
                )
              }
            >
              Volver
            </Button>


            <Button
              variant="outline-success"
              type="button"
              disabled={saving}
              onClick={() =>
                ejecutarAcreditacion({
                  generarSaldo:
                    false,
                })
              }
            >
              {saving
                ? "Procesando..."
                : `Acreditar ${toMoney(
                  montoNumero
                )} sin generar saldo`}
            </Button>


            <Button
              variant="success"
              type="button"
              disabled={saving}
              onClick={() =>
                ejecutarAcreditacion({
                  generarSaldo:
                    true,
                })
              }
            >

              {saving ? (

                <>
                  <Spinner
                    size="sm"
                    animation="border"
                    className="me-2"
                  />

                  Procesando...
                </>

              ) : (

                `Acreditar y programar ${toMoney(
                  diferenciaMonto
                )}`

              )}

            </Button>
          </>

        ) : (

          <>
            <Button
              variant="secondary"
              disabled={saving}
              onClick={cerrar}
            >
              Cancelar
            </Button>


            <Button
              variant="success"
              disabled={
                saving ||
                !row
              }
              onClick={
                confirmar
              }
            >

              {saving ? (

                <>
                  <Spinner
                    size="sm"
                    animation="border"
                    className="me-2"
                  />

                  Acreditando...
                </>

              ) : (

                "Acreditar"

              )}

            </Button>
          </>

        )}

      </Modal.Footer>

    </Modal>
  );
}